var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{directives:[{name:"tooltip",rawName:"v-tooltip:top",value:('Displayed in your local time'),expression:"'Displayed in your local time'",arg:"top"}],staticClass:"text-dark w-4 h-4 mr-1",attrs:{"icon":"Info"}})}
var staticRenderFns = []

export { render, staticRenderFns }